import { useState, useEffect } from 'react';
import { CheckBox, List, Popup, Tooltip } from 'devextreme-react';
import { Button, TextBox } from 'devextreme-react';
import { useScreenSize } from '../../../../../utils/media-query';
import { useAppSelector } from '../../../../../contexts/hooks';
import { newToast } from '../../../..';
import { ToolbarItem } from 'devextreme-react/popup';
import { SendResultByEmail } from '../../../../../types/types.orders';
import { UseApiResults } from '../../../../../api/api.results';

interface SendMailResulsProps {
  visible: boolean;
  setVisible: ({ visible }) => void;
  lstStudies: number[] | undefined;
  patientData?: any; // Tipo específico según tu aplicación
  orderData?: any; // Tipo específico según tu aplicación
}

export const SendMailResuls = ({ visible, setVisible, lstStudies, patientData: propPatientData, orderData: propOrderData }: SendMailResulsProps) => {
  const { isMedium, isSmall, isXSmall } = useScreenSize();
  const EmailServiceFieldPatient = useAppSelector((x) => x.configuration.Data?.Config_General.find((cfg) => cfg.Cgn_Nombre === 'EmailServiceFieldPatient')?.Cgn_Resultado);
  const info = useAppSelector((x) => x.configuration.Data?.SystemFields);
  const globalOrderData = useAppSelector((x) => x.globalOrders.CurrentOrder.OrderData);
  const globalPatientData = useAppSelector((x) => x.globalOrders.CurrentOrder.PatientData);
  const attachments = useAppSelector((x) => x.globalOrders.CurrentOrder.Attachments);
  const [attachmentsStudies, setAttachmentsStudies] = useState(true);
  const [attachment, setAttachment] = useState(true);
  const [loading, setLoading] = useState(false);
  const [emailFields, setEmailFields] = useState<{ id: string; value: string }[]>([]);
  const [emailInput, setEmailInput] = useState<string>('');
  const { senResultByMail } = UseApiResults();
  const idOrd = useAppSelector((x) => x.globalOrders.CurrentOrder.IdOrder);

  useEffect(() => {
    if (!visible) return;

    // Usar los datos proporcionados por props o caer en los datos globales
    const effectiveOrderData = propOrderData || globalOrderData;
    const effectivePatientData = propPatientData || globalPatientData;

    const matchedField = info?.find((field) => field.Dfc_Equivalencia === EmailServiceFieldPatient);

    if (matchedField) {
      if (matchedField.Dfc_Tabla === 'Ordenes' && effectiveOrderData?.AditionalFields) {
        const emailList = effectiveOrderData.AditionalFields[matchedField.Dfc_Equivalencia] || [];
        const formattedEmails = Array.isArray(emailList) ? emailList : emailList ? [emailList] : [];
        const emailFieldsData = formattedEmails.map((email, index) => ({
          id: `email_${index}_${Date.now()}`,
          value: email
        }));
        setEmailFields(emailFieldsData);
      } else if (matchedField.Dfc_Tabla === 'Pacientes' && effectivePatientData?.AditionalFields) {
        const emailList = effectivePatientData.AditionalFields[matchedField.Dfc_Equivalencia] || [];
        const formattedEmails = Array.isArray(emailList) ? emailList : emailList ? [emailList] : [];
        const emailFieldsData = formattedEmails.map((email, index) => ({
          id: `email_${index}_${Date.now()}`,
          value: email
        }));
        setEmailFields(emailFieldsData);
      } else {
        setEmailFields([]);
      }
    } else {
      setEmailFields([]);
    }
  }, [visible, propPatientData, propOrderData]);

  const handleClose = () => {
    setVisible({ visible: false });
  };

  const handleAddEmail = () => {
    const trimmedEmail = emailInput.trim();
    if (trimmedEmail && validateEmail(trimmedEmail)) {
      const newEmailField = {
        id: `email_${emailFields.length}_${Date.now()}`,
        value: trimmedEmail
      };
      
      // Verificar que no existe un campo con el mismo valor
      const existingField = emailFields.find(field => field.value === trimmedEmail);
      if (!existingField) {
        setEmailFields([...emailFields, newEmailField]);
        setEmailInput('');
      } else {
        newToast('WARNING', 'El correo electrónico ya está en la lista.', 5);
      }
    } else {
      newToast('WARNING', 'El correo electrónico no es válido.', 5);
    }
  };

  // Función para eliminar un campo de email
  const handleRemoveEmailField = (id: string) => {
    setEmailFields(emailFields.filter(field => field.id !== id));
  };

  const handleChangeAttachmentStudies = (e: any) => {
    setAttachmentsStudies(e);
  };

  const handleChangeAttachment = (e: any) => {        
    setAttachment(e);
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const onSaveClick = () => {
    if (!idOrd || idOrd === -1) {
      return;
    }
    if (emailFields.length === 0) {
      newToast('WARNING', 'Debe ingresar al menos un correo de destino', 5);
      return;
    }

    const emailAddresses = emailFields.map(field => field.value);

    const dataToSend: SendResultByEmail = {
      IdOrder: idOrd,
      Destinators: emailAddresses,
      Studies: lstStudies || [],
      IncludeAttachments: attachment,
      IncludeAttachmentsStudies: attachmentsStudies,
    };
    console.log('dataToSend', dataToSend);
    newToast('INFO', 'Se está enviando el correo electrónico, esto puede tardar algunos minutos.', 5);
    senResultByMail(dataToSend);

    setVisible({ visible: false });
  };

  return (
    <Popup visible={visible} fullScreen={isMedium || isSmall || isXSmall} width={600} maxHeight={700} title='Enviar por correo electrónico' onHiding={handleClose} showCloseButton={true}>
      <div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <TextBox id='emailInput' value={emailInput} onValueChanged={(e) => setEmailInput(e.value)} label='Agregar correo' labelMode='static' placeholder='Escribe un correo' onEnterKey={handleAddEmail} style={{ flex: 1, marginRight: '8px' }} />
          <Button stylingMode='text' icon='add' onClick={handleAddEmail} type='default' />
        </div>
        <div className='widget-container'>
          {emailFields.map((field) => (
            <div key={field.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <TextBox
                value={field.value}
                readOnly={true}
                placeholder='Correo electrónico'
                style={{ flex: 1, marginRight: '8px' }}
              />
              <Button 
                stylingMode='text' 
                icon='remove' 
                onClick={() => handleRemoveEmailField(field.id)} 
                type='danger' 
              />
            </div>
          ))}
          {emailFields.length > 0 && (
            <div style={{ fontSize: '11px', color: '#666', marginTop: '5px' }}>
              Los correos electrónicos se enviarán a estas direcciones.
            </div>
          )}
        </div>
      </div>
      {attachments && attachments.length > 0 && (
        <>
          <hr />
          <h5>Incluir archivos adjuntos?</h5>
          <p style={{ marginTop: -20 }}>Esta orden contiene archivos adjuntos que pueden ser enviados por correo electrónico.</p>
        </>
      )}
      {attachments && attachments.filter((x) => x.Oad_Es_Id).length > 0 && (
        <div className='widget-container'>
          <div className='dx-field' id='attachmentsest'>
            <div className='dx-field-label'>Incluir adjuntos de estudios?</div>
            <div className='dx-field-value'>
              <CheckBox defaultValue={true} elementAttr={{ 'aria-label': 'Checked' }} onValueChange={handleChangeAttachmentStudies} />
            </div>
          </div>
          <Tooltip target={'#attachmentsest'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
            Adjuntos que están asociados a un estudio.
          </Tooltip>
        </div>
      )}

      {attachments && attachments.filter((x) => !x.Oad_Es_Id).length > 0 && (
        <div className='widget-container' style={{ marginTop: -15 }}>
          <div className='dx-field' id='attachments'>
            <div className='dx-field-label'>Incluir archivos adjuntos no asociados a estudios?</div>
            <div className='dx-field-value'>
              <CheckBox defaultValue={true} elementAttr={{ 'aria-label': 'Checked' }} onValueChange={handleChangeAttachment} />
            </div>
          </div>
          <Tooltip target={'#attachments'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
            Adjuntos que no están asociados a un estudio.
          </Tooltip>
        </div>
      )}

      <ToolbarItem toolbar='bottom' location='after'>
        <div className={`form-popup-buttons-container `}>
          <Button stylingMode='contained' text='Cancelar' type={'normal'} onClick={handleClose} />
          <Button stylingMode='contained' text='Enviar' type={loading ? 'normal' : 'default'} disabled={loading} onClick={onSaveClick} />
        </div>
      </ToolbarItem>
    </Popup>
  );
};
